export default __webpack_public_path__ + "static/media/Shadowed Valleys-19.6a25a580.jpg";